import { Fields, SectionN } from "../models/column-settings.model";

export function getSectionWiseFlatCols(section: SectionN[]): Fields[]{
    let fields = [];
    section.forEach(element => {
        element?.fields.forEach((field) => {
            if(field?.childFields.length > 0){
                fields = [...fields, ...field?.childFields]
            }else{
                fields.push(field);
            }
        });
    });
    return fields;
}
